export const minecraft1194 = {
  version: '1.19.4',
  title: 'The Wild Update',
  image: 'https://www.minecraft.net/content/dam/minecraftnet/games/minecraft/key-art/Vanilla-PMP_Collection-Carousel-0_The-Wild-Update_1280x768.jpg',
  releases: [
    {
      id: "120hY1Wvj",
      version: "1.0.4",
      date: "Jul 5, 2025",
      changelog: "Versión estable para Minecraft 1.19.4 con todos los mods optimizados",
      downloadUrl: "https://modrinth.com/modpack/simonuwu-fabric-project/version/1.0.4-1.19.4",
      curseforgeUrl: "https://www.curseforge.com/minecraft/modpacks/simonuwu-fabric-project",
      isBeta: false
    }
  ]
};